import { Dispatch, useReducer } from 'react';

import {
  Action,
  BASE_FAILURE,
  BASE_INIT,
  BASE_SUCCESS,
  IMutationFn,
  INITIAL_STATE,
  IState,
} from '../helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAuthReducer = (): [IState, Dispatch<any>] => {
  const [state, dispatch] = useReducer<IMutationFn>((ps, a) => {
    switch (a?.type) {
      case Action.AUTH:
        return { ...ps, ...BASE_INIT };
      case Action.AUTH_FAILURE:
        return { ...ps, ...BASE_FAILURE };
      case Action.AUTH_SUCCESS:
        return { ...ps, ...BASE_SUCCESS, token: a?.token, user: a?.user };

      case Action.LOGOUT:
        return { ...ps, ...INITIAL_STATE };

      case Action.RESTORE_SESSION:
        return { ...ps, ...BASE_INIT };
      case Action.RESTORE_SESSION_FAILURE:
        return { ...ps, ...BASE_FAILURE };
      case Action.RESTORE_SESSION_SUCCESS:
        return { ...ps, ...BASE_SUCCESS, token: a?.token, user: a?.user };

      default:
        throw new Error(`Unknow action type: ${a?.type}`);
    }
  }, INITIAL_STATE as never);

  return [state, dispatch];
};
